// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "attention-3WCI4";
var _3 = "attention__title-1tH7n";
var _4 = "attention__text-3CNZg";
export { _1 as "__esModule", _2 as "attention", _3 as "attention__title", _4 as "attention__text" }
export default { "__esModule": _1, "attention": _2, "attention__title": _3, "attention__text": _4 }
